import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-purchase-widget',
  templateUrl: './purchase-widget.component.html',
  styleUrl: './purchase-widget.component.scss'
})
export class PurchaseWidgetComponent implements OnInit, AfterViewInit {
  urlSafe: SafeResourceUrl = '';
  state:string = "CA";
  widgetUrl: string = environment.widgetUrl;
  constructor(public em: EventsManager,private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.widgetUrl+"?state="+this.em.selectedState.abbr+"&organization="+this.em.orgId+"&branding=sgdp");
  }

  ngAfterViewInit(){
    window.scroll(0,0);
  }
}
